module.exports = __webpack_public_path__ + "img/theme16.6ebbf90d.png";